import { Driver } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import createGroupFilter from "@/utilities/createGroupFilter";

/**
 * Returns all users (Max. 10000)

 * @returns - {@link User[]}.
 */
export function useUsersWithKeys() {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();
  return useQuery({
    queryKey: ["users", activeSessionId, groups, groupFilterCondition],

    queryFn: ({ signal }) => {
      const now_utc = new Date(new Date().toUTCString());
      const filter = createGroupFilter(groups, groupFilterCondition, {
        isDriver: true,
        fromDate: now_utc,
        toDate: now_utc,
      });

      return geotabClient
        .get("User", filter, 10000, signal)
        .then(users => users.filter(u => u.isDriver && (u as Driver).keys.length > 0));
    },
  });
}
